import ModMarketRouteStatus from "discourse/plugins/discourse-mod-market/discourse/components/mod-market-route-status";

export default <template><ModMarketRouteStatus @error={{@model}} /></template>;
